<template>
  <div class="page">
    <ion-grid fixed>
      <ion-row align-items-stretch v-if="chargingStatus">
        <ion-col size="12" size-md="12" class="col-padding">
          <ion-grid>
            <ion-row v-if="reservationType != ''">
              <ion-col class="grid-info left-top">Voltage</ion-col>
              <ion-col class="grid-info center-top">Current</ion-col>
              <ion-col class="grid-info center-top">Power</ion-col>
              <ion-col class="grid-info right-top">Temp</ion-col>
            </ion-row>
            <ion-row v-if="reservationType != ''">
              <ion-col class="grid-info-data left-bottom">{{chargingStatus.voltage}} V</ion-col>
              <ion-col class="grid-info-data center-bottom">{{chargingStatus.current}} A</ion-col>
              <ion-col class="grid-info-data center-bottom">{{chargingStatus.power}} kW</ion-col>
              <ion-col class="grid-info-data right-bottom">{{chargingStatus.temperature}}&deg;C</ion-col>
            </ion-row>
            <ion-row v-if="reservationType != ''">
              <span id="doughnutCanvasWebtitle" class="chart-title" size="12">
                <p v-if="chargingStatus.percentageCharged != 100">Charging In-Progress</p>
                <p v-if="chargingStatus.percentageCharged == 100">Charging Completed</p>
              </span>
            </ion-row>
            <ion-row class="ion-justify-content-center" >
              <ion-col size-xl="4" size-md="12">
                <canvas id="doughnutCanvasWeb" width="200" height="200"></canvas>
              </ion-col>
            </ion-row>
            <!-- Below code is commnted on 13-05-2025 because based charge type we are displaying datas -->
            <!-- <ion-row>
              <ion-col class="grid-info single-top" size="5" size-lg="4">Time Remaining</ion-col>
              <ion-col size-lg="4" size="2">&nbsp;</ion-col>
              <ion-col class="grid-info  single-top" size-lg="4" size="5">Time Completed</ion-col>
            </ion-row>
            <ion-row>
              <ion-col class="grid-info-data single-middle" size-lg="4" size="5">{{chargingStatus.timeRemaining}}</ion-col>
              <ion-col size-lg="4" size="2">&nbsp;</ion-col>
              <ion-col class="grid-info-data single-middle" size-lg="4" size="5">{{chargingStatus.timeCompleted}}</ion-col>
            </ion-row>
            <ion-row>
              <ion-col class="grid-info single-middle" size-lg="4" size="5">Energy Balance</ion-col>
              <ion-col size-lg="4" size="2">&nbsp;</ion-col>
              <ion-col size-lg="4" size="5" class="grid-info single-middle">Energy Delivered</ion-col>
            </ion-row>
            <ion-row>
              <ion-col
                size-lg="4"
                size="5"
                class="grid-info-data single-bottom"
              >{{chargingStatus.unitsBalance}} kWh</ion-col>
              <ion-col size-lg="4" size="2">&nbsp;</ion-col>
              <ion-col
                size-lg="4"
                size="5"
                class="grid-info-data single-bottom"
              >{{chargingStatus.unitsConsumed}} kWh</ion-col>
            </ion-row> -->
            <ion-row>
              <ion-col>
                <ion-grid>
                  <ion-row>
                    <ion-col class="grid-info single-top" size-lg="5" size="5.5">Time Remaining</ion-col>
                    <ion-col size-lg="2" size="1">&nbsp;</ion-col>
                    <ion-col class="grid-info single-top" size-lg="5" size="5.5" >Time Completed</ion-col>
                  </ion-row>
                  <ion-row >
                    <ion-col class="grid-info-data single-middle" size-lg="5" size="5.5">{{chargingStatus.timeRemaining}}</ion-col>
                    <ion-col size-lg="2" size="1">&nbsp;</ion-col>
                    <ion-col class="grid-info-data single-middle" size-lg="5" size="5.5">{{chargingStatus.timeCompleted}}</ion-col>
                  </ion-row><br>
                  <ion-row>
                    <ion-col size-lg="1" size="1">&nbsp;</ion-col>
                    <ion-col class="grid-info  single-top" size-lg="5" size="5.5">Energy Delivered</ion-col>
                  </ion-row>
                  <ion-row>
                    <ion-col size-lg="1" size="1">&nbsp;</ion-col>
                    <ion-col class="grid-info-data single-middle" size-lg="5" size="5.5">{{chargingStatus.unitsConsumed}}</ion-col>
                  </ion-row>
                </ion-grid>
                <!-- <ion-grid v-if="reservationType == 'UB'">
                  <ion-row>
                    <ion-col class="grid-info single-top" size-lg="5" size="5.5">Time Remaining</ion-col>
                    <ion-col size-lg="2" size="1">&nbsp;</ion-col>
                    <ion-col  class="grid-info single-top" size-lg="5" size="5.5">Energy Balance</ion-col>
                  </ion-row>
                  <ion-row>
                    <ion-col class="grid-info-data single-middle" size-lg="5" size="5.5">{{chargingStatus.timeRemaining}}</ion-col>
                    <ion-col size-lg="2" size="1">&nbsp;</ion-col>
                    <ion-col class="grid-info-data single-middle" size-lg="5" size="5.5">{{chargingStatus.unitsBalance}} kWh</ion-col>
                  </ion-row>
                  <br>
                  <ion-row>
                    <ion-col size-lg="1" size="1">&nbsp;</ion-col>
                    <ion-col class="grid-info  single-top" size-lg="5" size="5.5">Energy Delivered</ion-col>
                  </ion-row>
                  <ion-row>
                    <ion-col size-lg="1" size="1">&nbsp;</ion-col>
                    <ion-col class="grid-info-data single-middle" size-lg="5" size="5.5">{{chargingStatus.unitsConsumed}}</ion-col>
                  </ion-row>
                </ion-grid> -->
                <!-- <ion-grid v-if="reservationType == 'TB'">
                  <ion-row>
                    <ion-col class="grid-info single-top" size-lg="5" size="5.5">Time Remaining</ion-col>
                    <ion-col size-lg="2" size="1">&nbsp;</ion-col>
                    <ion-col class="grid-info  single-top" size-lg="5" size="5.5">Time Completed</ion-col>
                  </ion-row>
                  <ion-row>
                    <ion-col class="grid-info-data single-middle" size-lg="5" size="5.5">{{chargingStatus.timeRemaining}}</ion-col>
                    <ion-col size-lg="2" size="1">&nbsp;</ion-col>
                    <ion-col class="grid-info-data single-middle" size-lg="5" size="5.5">{{chargingStatus.timeCompleted}}</ion-col>
                  </ion-row><br>
                  <ion-row>
                    <ion-col size-lg="1" size="1">&nbsp;</ion-col>
                    <ion-col class="grid-info single-middle" size-lg="5" size="5.5">Energy Delivered</ion-col>
                  </ion-row>
                  <ion-row>
                    <ion-col size-lg="1" size="1">&nbsp;</ion-col>
                    <ion-col class="grid-info-data single-bottom" size-lg="5" size="5.5">{{chargingStatus.unitsConsumed}} kWh</ion-col>
                  </ion-row>
                </ion-grid> -->
              </ion-col>
            </ion-row>
          </ion-grid>
        </ion-col>
      </ion-row>
    </ion-grid>
    <!-- <div class="spinner">
      <ion-spinner v-if="loaderTab"></ion-spinner>
    </div> -->
    
    <!-- commented by sindhu, ion-loading not support for iOS -->
    <!-- <ion-grid>
      <ion-row>
        <ion-col>
          <ion-loading :is-open="isLoading" class="custom-loading" spinner="lines-sharp" message="Please Wait..."></ion-loading>
        </ion-col>
      </ion-row>
    </ion-grid> -->
  </div>
</template>

<script>
import { defineComponent } from "vue";
import { IonGrid, IonRow, IonCol, IonLoading } from "@ionic/vue";

import { EVCStationReservationService } from "../../service/evcstation/reservation.service";

import { LocalStorage } from "../../data/localstorage";
import { tryParseServiceError, migratedTryParseServiceError } from "../../service";
import { Chart } from "chart.js/auto";
import { ToastUtils } from "../../util/toast-utils";
import { loadingController } from "@ionic/vue";

export default defineComponent ({
  name: 'chargingStatusView',
  components: {
    IonGrid, IonRow, IonCol, IonLoading
  },
  async mounted() {
    // Add this code by sindhu, instead of ion-loading support for iOS
    const loading = await loadingController.create({
      message: 'Please Wait...',
      spinner: 'lines-sharp'
    })

    await loading.present();
    this.loaderTab = true;
    // this.isLoading = true;
    let type = JSON.parse(localStorage.getItem('reservationTypeInfo'));
    this.reservationType = type.code;
    this.timeout = setTimeout(async() => {
    //    let type = JSON.parse(localStorage.getItem('reservationTypeInfo'));
    // this.reservationType = type.code;
      if (this.chargingStatus != null) {
        // this.displayStatusData = true;
        this.chargingPercentage = this.chargingStatus.percentageCharged;
        //Refresh the chart often when the Charging is in Progress
        if (this.chargingStatus.percentageCharged != 100)
        this.startRefresh("doughnutCanvasWeb");

        // 2.0
        if(this.myChart) {
          this.myChart.destroy();
          this.myChart = null;
        }
        // 2.0
        this.createChart("doughnutCanvasWeb", "W", [
          this.chargingStatus.percentageCharged,
          this.chargingStatus.percentageRemaining,
        ]);
      }
      await loading.dismiss();
      this.loaderTab = false;
      // this.isLoading = false;
      
    }, 10000);
    try {
      this.chargingStatus = await new EVCStationReservationService().viewChargingStatusByUser(
      { id: this.$route.params.bookingId },
      new LocalStorage().user
      );
      // new EVCStationReservationService()
      // .viewChargingStatusByUser({ id: this.$route.params.bookingId },new LocalStorage().user).then((status) => {
      //   this.chargingStatus = status;

      //   if (this.chargingStatus != null) {
      //     this.displayStatusData = true;
      //     this.chargingPercentage = this.chargingStatus.percentageCharged;
      //     //Refresh the chart often when the Charging is in Progress
      //     if (this.chargingStatus.percentageCharged != 100)
      //     this.startRefresh("doughnutCanvasWeb");

      //     // 2.0
      //     if(this.myChart) {
      //       this.myChart.destroy();
      //       this.myChart = null;
      //     }
      //     // 2.0
      //     this.createChart("doughnutCanvasWeb", "W", [
      //       this.chargingStatus.percentageCharged,
      //       this.chargingStatus.percentageRemaining,
      //     ]);
      //   }

      //   this.loaderTab = false;
      // }); 
    } catch(error) {
      this.displayStatusData = false;
      await loading.dismiss();
      // this.loaderTab = false;
      this.isLoading = false;
      // new ToastUtils().presentToast(error.response.data.errors[0].detail);
      let serviceError = migratedTryParseServiceError(error);
      new ToastUtils().presentToast(serviceError.description);
    }
  },
  unmounted() {
    try {
      clearInterval(this.interval);
    } catch(error) {
      let serviceError = migratedTryParseServiceError(error);
      new ToastUtils().presentToast(serviceError.description);
    }
  },
  data() {
    return {
      isLoading: false,
      chargingStatus: null,
      chargingPercentage: 0,
      interval: 0,
      myChart: null,
      timeout: null,
      loaderTab: false,
      displayStatusData: false,
      reservationType : ""
    }
  },
  methods: {
    makePercentage(thischart) {
      try {
        Chart.register({
          id: 'customPlugin',
          beforeDraw: (thischart) => {
            // console.log(thischart)
            var width = thischart.width,
            height = thischart.height,
            ctx = thischart.ctx,
            type = thischart.config.type;
            // console.log(type)
            if (type == "doughnut") {
              var percent = Math.round(
              (thischart.config.data.datasets[0].data[0] * 100) /
                (thischart.config.data.datasets[0].data[0] +
                thischart.config.data.datasets[0].data[1])
              );
              var oldFill = ctx.fillStyle;
              var fontSize = ((height - thischart.chartArea.top) / 90).toFixed(2);

              ctx.restore();
              ctx.font = fontSize + "em sans-serif";
              ctx.textBaseline = "middle";

              var text = percent + "%",
              textX = Math.round((width - ctx.measureText(text).width) / 2),
              textY = (height + thischart.chartArea.top) / 2;

              ctx.fillStyle =
              thischart.config.data.datasets[0].backgroundColor['#36A2EB'];
              ctx.fillText(text, textX, textY);
              ctx.fillStyle = oldFill;
              ctx.save();
            }
          }
        })
      //   Chart.pluginService.register({
      //   beforeDraw: function (thischart) {
      //     var width = thischart.chart.width,
      //     height = thischart.chart.height,
      //     ctx = thischart.chart.ctx,
      //     type = thischart.config.type;
      //     if (type == "doughnut") {
      //       var percent = Math.round(
      //       (thischart.config.data.datasets[0].data[0] * 100) /
      //         (thischart.config.data.datasets[0].data[0] +
      //         thischart.config.data.datasets[0].data[1])
      //       );
      //       var oldFill = ctx.fillStyle;
      //       var fontSize = ((height - thischart.chartArea.top) / 90).toFixed(2);

      //       ctx.restore();
      //       ctx.font = fontSize + "em sans-serif";
      //       ctx.textBaseline = "middle";

      //       var text = percent + "%",
      //       textX = Math.round((width - ctx.measureText(text).width) / 2),
      //       textY = (height + thischart.chartArea.top) / 2;

      //       ctx.fillStyle =
      //       thischart.config.data.datasets[0].backgroundColor['#36A2EB'];
      //       ctx.fillText(text, textX, textY);
      //       ctx.fillStyle = oldFill;
      //       ctx.save();
      //     }
      //   },
      // });
      } catch(error) {
        let serviceError = migratedTryParseServiceError(error);
        new ToastUtils().presentToast(serviceError.description);
      }
      
    },
    createChart(id, destination, chartData) {
      try {
        var ctx = document.getElementById(id);
        var ctxTitle = document.getElementById(id + "title");
        if(ctx != null) {
          if (chartData && chartData[0] != 100) {
            ctxTitle.className += " blink";
          }
          if (this.myChart) {
            this.myChart.data.datasets[0].data = chartData;
            this.myChart.update();
          } else {
              this.myChart = new Chart(ctx, {
                type: "doughnut",
                data: {
                labels: ["Completed", "Pending"],
                datasets: [
                {
                  label: "Current Status",
                  data: chartData,
                  backgroundColor: ["rgba(33, 178, 75, 1)", "rgba(4, 22, 72, 1)"],
                  hoverBackgroundColor: ["#d66c6c", "#d66c6c"],
                },
                ],
              },
              options: {
                responsive: destination == "M" ? true : true,
                labelFontFamily: "Arial",
                labelFontStyle: "normal",
                labelFontSize: 24,
                labelFontColor: "#666",
                legend: false,
                // cutoutPercentage: 80,
                cutout: "80%",
                title: {
                display: false,
                text: "Charging In-Progress",
                fontFamily: "Roboto Medium",
                fontSize: 16,
                fontColor: "#041648",
                },
              }
            });
          }
          this.makePercentage(this.myChart);
        } else {
          clearInterval(this.interval);
        }
      } catch(error) {
        this.isLoading = false;
        let serviceError = migratedTryParseServiceError(error);
        new ToastUtils().presentToast(serviceError.description);
      }
    },
    startRefresh(id) {
      this.interval = setInterval(() => {
        if(document.hidden) return;
        if (this.chargingStatus.percentageCharged == 100) {
          clearInterval(this.interval);
          var ctxTitle = document.getElementById(id + "title");
          ctxTitle.className = "chart-title";
        } else {
          new EVCStationReservationService()
          .viewChargingStatusByUser(
          { id: this.$route.params.bookingId },
          new LocalStorage().user
          )
          .then((chargingStatus) => {
            this.chargingStatus = chargingStatus;
            if (
                this.chargingPercentage != this.chargingStatus.percentageCharged
            ) {
                this.chargingPercentage = this.chargingStatus.percentageCharged;
                // 2.0
                if(this.myChart) {
                  this.myChart.destroy();
                  this.myChart = null;
                }
                // 2.0
                this.createChart("doughnutCanvasWeb", "W", [
                this.chargingStatus.percentageCharged,
                this.chargingStatus.percentageRemaining,
                ]);
            }
            if (this.chargingStatus.percentageCharged == 100) {
                clearInterval(this.interval);
                var ctxTitle = document.getElementById(id + "title");
                ctxTitle.className = "chart-title";
            }
          }).catch((error) => {
            this.isLoading = false;
            let serviceError = migratedTryParseServiceError(error);
            new ToastUtils().presentToast(serviceError.description);
          });
        }
      }, this.chargingStatus.refreshTime * 1000 || 30000);
    },
  },
  // destroyed() {
  //   clearInterval(this.interval);
  // },
})
</script>

<style scoped>
.donut-inner {
  margin-top: -100px;
  margin-bottom: 100px;
}
.donut-inner h5 {
  margin-bottom: 5px;
  margin-top: 0;
}
.graph-header {
  background-color: #ffffff;
  background-clip: border-box;
}
.graph-data {
  background-color: #21b24b;
}
.grid-info {
  margin: 0px auto;
  width: 100%;
  height: 30px;
  background-color: #041648;
  text-align: center;
  padding: 5px 0;
  position: relative;
  white-space: nowrap !important;
  z-index: 10;
  color: white;
}
.grid-info:after {
  background-color: #21b24b;
  content: "";
  display: block;
  position: absolute;
  top: 2px;
  left: 2px;
  right: 2px;
  bottom: 2px;
  z-index: -1;
}
.center-top:after {
  left: 1px !important;
  right: 1px !important;
  bottom: 1px !important;
}
.left-top:after {
  right: 1px !important;
  bottom: 1px !important;
}
 .right-top:after {
  left: 1px !important;;
  bottom: 1px !important;;
}
.center-bottom:after {
  left: 1px !important;
  right: 1px !important;
  top: 1px !important;
}
.left-bottom:after {
  right: 1px !important;
  top: 1px !important;
}
 .right-bottom:after {
  left: 1px !important;;
  top: 1px !important;;
}
.single-top:after {
  bottom : 1px !important;
}
.single-bottom:after {
  top : 1px !important;
}
.single-middle:after {
  bottom : 1px !important;
  top :  1px !important;
}
.grid-info-data {
  margin: 0px auto;
  width: 100%;
  height: 30px;
  background-color: #041648;
  text-align: center;
  vertical-align: middle;
  white-space: nowrap !important;
  padding: 5px 0;
  position: relative;
  z-index: 10;
}
.grid-info-data:after {
  background-color: white;
  content: "";
  display: block;
  position: absolute;
  top: 2px;
  left: 2px;
  right: 2px;
  bottom: 2px;
  z-index: -1;
}
.my-custom-class {
  background-color: #222;
  width: 50% !important;
}
.section--answer {
  float: right;
}
.charging--in-progress {
  /* background: transparent url(/assets/images/common/more/charging.gif) no-repeat center; */
  background-size: auto;
  background-position: 50% 85%;
}
.chart-title {
  font-family: "Roboto Medium" !important;
  font-size: 16px;
  color: #041648;
  text-align: center;
  width: 100%;
}
.blink {
  animation: blinker 0.6s linear infinite;
}
@keyframes blinker {
  50% {
    opacity: 0;
  }
}
.doughnutCanvasWebChart {
  text-align: center;
}
</style>